// extracted by mini-css-extract-plugin
export default {"component":"Breadcrumbs__component--slots-UcSoM","item":"Breadcrumbs__item--slots-eDVJh","active":"Breadcrumbs__active--slots-kAN2h Breadcrumbs__component--slots-UcSoM"};